export default "__VITE_ASSET__4f9d4fcd__"